export default __webpack_public_path__ + "static/media/tech-space.704516ca.jpg";